import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: props => ({
    display: props.isVisible ? 'block' : 'none',
    height: 'auto',
    marginBottom: -5,
    width: `${props.options.wideRatio}%`
  }),
  video: {
    height: 'auto',
    width: '100%'
  }
}));

export default function Video({ data }) {
  const classes = useStyles(data);

  return (
    <div className={classes.root}>
      {data.options.url ? (
        <video
          className={classes.video}
          src={data.options.url}
          autoPlay
          loop
          muted
        />
      ) : (
        <img
          alt="video"
          className={classes.video}
          src={require('../../../Editor/_assets/images/video_placeholder_350_350.png')}
        />
      )}
    </div>
  );
}